module.exports = __webpack_public_path__ + "static/media/org4.f94921ba.png";